import axios from '@/utils/axios';
import urlConfig from '@/utils/urlConfig';


export default {

    /**
     * /stl/merchant/acquirer
     * 分账-分账收单机构来账账号配置
     */
    acquirerAccountListApi: (data) => axios.apiPost(urlConfig.busiURL + '/stl/merchant/acquirer/list', data),
    acquirerAccountOrgListApi: () => axios.apiPost(urlConfig.busiURL + '/stl/merchant/acquirer/org/list'),
    acquirerAccountSaveApi: (data) => axios.apiPost(urlConfig.busiURL + '/stl/merchant/acquirer/create', data),
    acquirerAccountDelApi: (data) => axios.apiPost(urlConfig.busiURL + '/stl/merchant/acquirer/delete?id=' + data),


    /**
     * /stl/merchant
     * 分账-分账商户
     */
    settleMerchantSaveApi: (data) => axios.apiPost(urlConfig.busiURL + '/stl/merchant/create', data),
    settleMerchantEditApi: (data) => axios.apiPost(urlConfig.busiURL + '/stl/merchant/edit', data),
    settleMerchantDetailApi: (data) => axios.apiGet(urlConfig.busiURL + '/stl/merchant/get?merchantNo=' + data),
    settleMerchantPageApi: (data) => axios.apiPost(urlConfig.busiURL + '/stl/merchant/page?pageNo=' + data.pageNo + '&pageSize=' + data.pageSize, data),
    settleMerchantListApi: (data) => axios.apiPost(urlConfig.busiURL + '/stl/merchant/list', data),
    settleMerchantDelApi: (data) => axios.apiGet(urlConfig.busiURL + '/stl/merchant/delete?merchantNo=' + data),

    /**
     * 分账-银行来账记录
     * /stl/bank/flow
     */

    // 同步银行来账
    synchTranItemApi: (data) => axios.apiPost(urlConfig.busiURL + '/stl/bank/flow/synchTranItem', data),
    // 银来账流水分页查询
    bankFlowPageApi: ( data) => axios.apiPost(`${urlConfig.busiURL}/stl/bank/flow/page?pageNo=${data.pageNo}&pageSize=${data.pageSize}`, data),
    // 银来账流水列表查询
    bankFlowListApi: (data) => axios.apiPost(urlConfig.busiURL + '/stl/bank/flow/list', data),
    // 获取银行流水详情
    bankFlowDetailApi: (bankSerialNo) => axios.apiPost(urlConfig.busiURL + '/stl/bank/flow/get?bankSerialNo=' + bankSerialNo),
    // 根据来账流水匹配批次
    generateMatchesApi: (bankSerialNo) => axios.apiPost(`${urlConfig.busiURL}/stl/bank/flow/generateMatches?bankSerialNo=${bankSerialNo}`),
    bankFlowFeeRetryApi: (bankSerialNo) => axios.apiPost(`${urlConfig.busiURL}/stl/bank/flow/fee/retry?bankSerialNo=${bankSerialNo}`),
    // 批量处理多个来账流水匹配批次
    batchGenerateMatchesApi: (bankSerialNos) => axios.apiPost(urlConfig.busiURL + '/stl/bank/flow/batchGenerateMatches', bankSerialNos),
    // 根据商户号生成银行流水匹配
    generateMatchesByMerchantApi: (merchantNo) => axios.apiPost(`${urlConfig.busiURL}/stl/bank/flow/generateMatchesByMerchant?merchantNo=${merchantNo}`),
    // 取消匹配
    cancelMatchApi: (batchNo, bankSerialNo) => axios.apiPost(`${urlConfig.busiURL}/stl/bank/flow/cancelMatch?batchNo=${batchNo}&bankSerialNo=${bankSerialNo}`),
    // 获取匹配结果
    getMatchResultApi: (batchNo) => axios.apiPost(`${urlConfig.busiURL}/stl/bank/flow/getMatchResult?batchNo=${batchNo}`),


    // 自动匹配（按商户）
    autoMatchApi: (merchantNo) => axios.apiPost(`${urlConfig.busiURL}/stl/batch/match/merchantNo?merchantNo=${merchantNo}`),
    // 自动匹配（按批次号）
    autoMatchByBatchNoApi: (batchNo) => axios.apiPost(`${urlConfig.busiURL}/stl/batch/match/batchNo?batchNo=${batchNo}`),
    // 获取批次详情(含流水)
    batchDetailWithFlowsApi: (batchNo) => axios.apiPost(`${urlConfig.busiURL}/stl/batch/getDetailWithFlows?batchNo=${batchNo}`),

    // 取消批次所有匹配
    cancelBatchMatchApi: (batchNo) => axios.apiPost(`${urlConfig.busiURL}/stl/batch/match/cancel?batchNo=${batchNo}`),


    // 按批次生成清分计划
    genPlanByBatchApi: (batchNo) => axios.apiPost(`${urlConfig.busiURL}/stl/batch/settle/genPlan?batchNo=${batchNo}`),

    genPlanTryByBatchApi: (batchNo) => axios.apiPost(`${urlConfig.busiURL}/stl/batch/settle/genPlanTry?batchNo=${batchNo}`),



    /**
     * /stl/bank/flow/settle
     * 分账清算记录
     */

    // 分账清算记录列表
    listSettleApi: (data) => axios.apiPost(urlConfig.busiURL + '/stl/bank/flow/settle/list', data),

    //根据银行流水号生成清分计划
    generateSettlePlanApi: (bankSerialNo) => axios.apiPost(`${urlConfig.busiURL}/stl/bank/flow/settle/genPlan?bankSerialNo=${bankSerialNo}`),
    //根据银行流水号生成清分计划
    generateSettlePlantryApi: (bankSerialNo) => axios.apiPost(`${urlConfig.busiURL}/stl/bank/flow/settle/genPlanTry?bankSerialNo=${bankSerialNo}`),


    // 分账清算记录分页查询
    pageSettleApi: (  data) => axios.apiPost(`${urlConfig.busiURL}/stl/bank/flow/settle/page?pageNo=${data.pageNo}&pageSize=${data.pageSize}`, data),
    // 获取清分详情
    getSettleDetailApi: (settleSerialNo) => axios.apiPost(`${urlConfig.busiURL}/stl/bank/flow/settle/get?settleSerialNo=${settleSerialNo}`),
    // 清分操作
    executeSettleApi: (settleSerialNo) => axios.apiPost(`${urlConfig.busiURL}/stl/bank/flow/settle/execute/settleSeq?settleSerialNo=${settleSerialNo}`),
    //根据流水号清分
    executeSettleByFlowApi: (bankSerialNo) => axios.apiPost(`${urlConfig.busiURL}/stl/bank/flow/settle/execute/flowSeq?bankSerialNo=${bankSerialNo}`),
    //根据批次号进行清分
    executeSettleByBatchApi: (batchNo) => axios.apiPost(`${urlConfig.busiURL}/stl/bank/flow/settle/execute/batchNo?batchNo=${batchNo}`),
    //根据批次号进行重试
    batchSettleRetryApi: (batchNo) => axios.apiPost(`${urlConfig.busiURL}/stl/bank/flow/settle/retry/batchNo?batchNo=${batchNo}`),

    //清分执行重试
    settleRetryApi: (settleSerialNo) => axios.apiPost(`${urlConfig.busiURL}/stl/bank/flow/settle/retry?settleSerialNo=${settleSerialNo}`),
    //清分作废
    invalidlSettleApi: (settleSerialNo) => axios.apiPost(`${urlConfig.busiURL}/stl/bank/flow/settle/invalid?settleSerialNo=${settleSerialNo}`),




    /**
     * /stl/batch
     * 分账登记批次
     */
    batchListApi: (data) => axios.apiPost(urlConfig.busiURL + '/stl/batch/list', data),
    batchPageApi: (data) => axios.apiPost(urlConfig.busiURL + '/stl/batch/page?pageNo=' + data.pageNo + '&pageSize=' + data.pageSize, data),
    batchDetailApi: (data) => axios.apiPost(urlConfig.busiURL + '/stl/batch/get?batchNo=' + data),
    batchinvalidApi: (data) => axios.apiPost(urlConfig.busiURL + '/stl/batch/invalid', data),


    /**
     * 商户签名管理
     */
// 商户签名管理
    getMerchantSignInfoApi: (merchantNo) => axios.apiGet(urlConfig.busiURL + `/stl/mch/sign-info/getByMchNo?merchantNo=${merchantNo}`),
    addMerchantSignInfoApi: (data) => axios.apiPost(urlConfig.busiURL + '/stl/mch/sign-info', data),
    updateMerchantSignInfoApi: (data) => axios.apiPut(urlConfig.busiURL + '/stl/mch/sign-info', data),
    deleteMerchantSignInfoApi: (merchantNo) => axios.apiDelete(urlConfig.busiURL + `/stl/mch/sign-info/delByMchNo?merchantNo=${merchantNo}`),
    pageMerchantSignInfoApi: (data) => axios.apiPost(urlConfig.busiURL + '/stl/mch/sign-info/page?pageNo=' + (data.pageNo || 1) + '&pageSize=' + (data.pageSize || 10), data),


};
